<div class="popupContainer">
  <div class="popupContent">
    <button class="closePopup popup fa fa-close" (click)="closePopup()"></button>
    <div>
        <ng-content></ng-content>
    </div>
  </div>
</div>
